import alt from 'epic-react-common/src/alt';
// import { Immutable } from 'seamless-immutable';
import {datasource} from 'alt-utils/lib/decorators';
import NewsLetterActions from '../actions/NewsLettersActions';
import NewsLetterSource from '../sources/NewsLetterSource';

@datasource(NewsLetterSource)
class NewsLetterStore {
    constructor() {
        this.state = {
            loading: false,
            isLoggedIn: false,
            email: '',
            success: false,
            checked: false,
            hasSubscribed: false
        };

        this.bindActions(NewsLetterActions);
        this.registerAsync(NewsLetterSource);
    }

    onGetSubscriptionStatus(data) {
        this.setState({
            loading: true,
            error: ''
        });
        this.getInstance().getSubscriptionStatus(data);
    }

    onGetSubscriptionStatusSuccess(response) {
        if (response && response.data && !response.data.error) {
            const state = response.data;
            state.loading = false;
            state.checked = true;
            state.hasSubscribed = response.data.listSubscribed && response.data.productSubscribed;
            this.setState(state);
        } else if (response.data.error) {
            this.setState({
                loading: false,
                checked: true,
                error: response.data.error
            });
        } else {
            console.error('Unknown Error', response);
            this.setState({
                loading: false,
                checked: true
            });
        }
    }

    onGetSubscriptionStatusFailure(response) {
        console.error('onGetSubscriptionStatusFailure() could not load comments data into store');
        this.setState({
            loading: false
        });
    }

    onSignUpNewsLetter(data) {
        this.setState({
            loading: true,
            error: ''
        });
        this.getInstance().signUpNewsLetter(data);
    }

    onSignUpNewsLetterSuccess(response) {
        if (response && response.data && response.data.ok) {
            this.setState({
                loading: false,
                success: true
            });
        } else if (response.data.error) {
            const state = {
                loading: false,
                checked: false,
                error: response.data.error
            };

            // if error is 1000
            // surpress this error
            if (response.data.error === 1000) {
                state.hasSubscribed = true;
                state.error = false;
            }

            this.setState(state);
        } else {
            console.error('Unknown error!', response);
            this.setState({
                loading: false,
                checked: false
            });
        }
    }

    onSignUpNewsLetterFailure(response) {
        console.error('onSignUpNewsLetterFailure()');
        this.setState({
            loading: false
        });
    }
}

export default alt.createStore(NewsLetterStore, 'NewsLetterStore');
export {NewsLetterStore as NewsLetterStoreUnwrapped};
